"use client";

import { c as _c } from "react/compiler-runtime";
import { useState, useEffect, useRef, useMemo } from "react";
import { createPortal } from "react-dom";
import { Plus, Minus, Maximize2, X } from "lucide-react";
import clsx from "clsx";
import { classNames, getPlatformClass } from "@/lib/utils";
// @ts-ignore
import { useAccountPlatform } from "@/hooks/useAccountPlatforms";
// @ts-ignore
import { countryEmojis } from "@/constants";
import { APIProvider, Map, useMap } from "@vis.gl/react-google-maps";
import Heatmap from "./Heatmap";
import { AnimatePresence, motion } from "framer-motion";
import { GlobeAltIcon } from "@heroicons/react/24/outline";
declare var google: any;

// ... (existing code)

// Mapping country names to ISO 2-letter codes for circle flags
const countryToCode: Record<string, string> = {
  "United States": "us",
  "United Kingdom": "gb",
  "United Arab Emirates": "ae",
  "South Africa": "za",
  "South Korea": "kr",
  "Saudi Arabia": "sa",
  "Puerto Rico": "pr",
  "New Zealand": "nz",
  "Hong Kong": "hk",
  "Czech Republic": "cz",
  "Costa Rica": "cr",
  "Bosnia and Herzegovina": "ba",
  "Russian Federation": "ru",
  "Dominican Republic": "do",
  "Democratic Republic of the Congo": "cd",
  "Central African Republic": "cf",
  "Cape Verde": "cv",
  "Cayman Islands": "ky",
  "Côte d'Ivoire": "ci",
  "El Salvador": "sv",
  "Equatorial Guinea": "gq",
  "French Guiana": "gf",
  "French Polynesia": "pf",
  "French Southern Territories": "tf",
  "Guinea-Bissau": "gw",
  "Iran, Islamic Republic of": "ir",
  "Isle of Man": "im",
  "Korea, Republic of": "kr",
  "Lao People's Democratic Republic": "la",
  "Macedonia, The Former Yugoslav Republic of": "mk",
  "Micronesia, Federated States of": "fm",
  "Netherlands Antilles": "an",
  "Palestinian Territory, Occupied": "ps",
  "Papua New Guinea": "pg",
  "Saint Barthélemy": "bl",
  "Saint Helena": "sh",
  "Saint Kitts and Nevis": "kn",
  "Saint Lucia": "lc",
  "Saint Martin": "mf",
  "Saint Pierre and Miquelon": "pm",
  "Saint Vincent and the Grenadines": "vc",
  "San Marino": "sm",
  "Sao Tome and Principe": "st",
  "Sierra Leone": "sl",
  "Sri Lanka": "lk",
  "Syrian Arab Republic": "sy",
  "Tanzania, United Republic of": "tz",
  "Trinidad and Tobago": "tt",
  "Turks and Caicos": "tc",
  "Virgin Islands, British": "vg",
  "Virgin Islands, U.S.": "vi",
  "Wallis and Futuna": "wf",
  "Western Sahara": "eh",
  India: "in",
  Germany: "de",
  Canada: "ca",
  France: "fr",
  Australia: "au",
  Japan: "jp",
  Netherlands: "nl",
  Sweden: "se",
  Brazil: "br",
  Spain: "es",
  Italy: "it",
  Mexico: "mx",
  Indonesia: "id",
  Russia: "ru",
  Turkey: "tr",
  Poland: "pl",
  Switzerland: "ch",
  Belgium: "be",
  Argentina: "ar",
  Philippines: "ph",
  Malaysia: "my",
  Nigeria: "ng",
  Chile: "cl",
  Colombia: "co",
  Portugal: "pt",
  Romania: "ro",
  Greece: "gr",
  Hungary: "hu",
  Pakistan: "pk",
  Austria: "at",
  Ukraine: "ua",
  Vietnam: "vn",
  Thailand: "th",
  Bulgaria: "bg",
  Morocco: "ma",
  Peru: "pe",
  Moldova: "md",
  Montenegro: "me",
  Monaco: "mc",
  Luxembourg: "lu",
  Lithuania: "lt",
  Latvia: "lv",
  Ireland: "ie",
  Egypt: "eg",
  Israel: "il",
  Singapore: "sg",
  Norway: "no",
  Finland: "fi",
  Denmark: "dk",
  Croatia: "hr",
  China: "cn",
  Venezuela: "ve",
  Qatar: "qa",
  Serbia: "rs",
  Slovakia: "sk",
  Belarus: "by",
  Ecuador: "ec",
  Slovenia: "si",
  Bangladesh: "bd",
  Iraq: "iq",
  Estonia: "ee",
  Georgia: "ge",
  Iceland: "is",
  Jamaica: "jm",
  Maldives: "mv",
  Mauritius: "mu",
  Mauritania: "mr",
  Mongolia: "mn",
  Myanmar: "mm",
  Namibia: "na",
  Nepal: "np",
  "New Caledonia": "nc",
  Nicaragua: "ni",
  Niger: "ne",
  Niue: "nu",
  "Norfolk Island": "nf",
  "Northern Mariana Islands": "mp",
  Andorra: "ad",
  Bahrain: "bh",
  Angola: "ao",
  Albania: "al",
  Algeria: "dz",
  Anguilla: "ai",
  Antarctica: "aq",
  "Antigua and Barbuda": "ag",
  Armenia: "am",
  Aruba: "aw",
  Azerbaijan: "az",
  Bahamas: "bs",
  Barbados: "bb",
  Belize: "bz",
  Benin: "bj",
  Bermuda: "bm",
  Bhutan: "bt",
  Bolivia: "bo",
  Botswana: "bw",
  "Burkina Faso": "bf",
  Burundi: "bi",
  Cambodia: "kh",
  Cameroon: "cm",
  Chad: "td",
  Comoros: "km",
  Congo: "cg",
  Cuba: "cu",
  Cyprus: "cy",
  Djibouti: "dj",
  Dominica: "dm",
  Eritrea: "er",
  Ethiopia: "et",
  Fiji: "fj",
  Gabon: "ga",
  Gambia: "gm",
  Ghana: "gh",
  Gibraltar: "gi",
  Greenland: "gl",
  Grenada: "gd",
  Guadeloupe: "gp",
  Guam: "gu",
  Guatemala: "gt",
  Guinea: "gn",
  Guyana: "gy",
  Haiti: "ht",
  Vatican: "va",
  Honduras: "hn",
  Jordan: "jo",
  Kazakhstan: "kz",
  Kenya: "ke",
  Kiribati: "ki",
  Kuwait: "kw",
  Kyrgyzstan: "kg",
  Lebanon: "lb",
  Lesotho: "ls",
  Liberia: "lr",
  Libya: "ly",
  Liechtenstein: "li",
  Macao: "mo",
  Madagascar: "mg",
  Malawi: "mw",
  Mali: "ml",
  Malta: "mt",
  Martinique: "mq",
  Mozambique: "mz",
  Nauru: "nr",
  Oman: "om",
  Palau: "pw",
  Panama: "pa",
  Paraguay: "py",
  Rwanda: "rw",
  Samoa: "ws",
  Senegal: "sn",
  Seychelles: "sc",
  Somalia: "so",
  Sudan: "sd",
  Suriname: "sr",
  Swaziland: "sz",
  Taiwan: "tw",
  Tajikistan: "tj",
  Tunisia: "tn",
  Turkmenistan: "tm",
  Tuvalu: "tv",
  Uganda: "ug",
  Uruguay: "uy",
  Uzbekistan: "uz",
  Vanuatu: "vu",
  Yemen: "ye",
  Zambia: "zm",
  Zimbabwe: "zw",
  Réunion: "re"
};
const mapStyle = [{
  featureType: "all",
  elementType: "geometry",
  stylers: [{
    color: "#fafafa"
  }] // Brighter land (was #f6f6f4)
}, {
  featureType: "all",
  elementType: "labels.text.fill",
  stylers: [{
    color: "#374151"
  }] // Darker gray for readability (gray-700)
}, {
  featureType: "all",
  elementType: "labels.text.stroke",
  stylers: [{
    visibility: "off"
  }] // Remove stroke for cleaner look
}, {
  featureType: "all",
  elementType: "labels.icon",
  stylers: [{
    visibility: "off"
  }]
}, {
  featureType: "landscape",
  elementType: "geometry",
  stylers: [{
    color: "#ffffff"
  }] // Pure white landscape
}, {
  featureType: "poi",
  elementType: "geometry",
  stylers: [{
    color: "#f5f5f5"
  }, {
    lightness: 21
  }]
}, {
  featureType: "poi.park",
  elementType: "geometry",
  stylers: [{
    color: "#dedede"
  }, {
    lightness: 21
  }]
}, {
  featureType: "road.highway",
  elementType: "geometry.fill",
  stylers: [{
    color: "#ffffff"
  }, {
    lightness: 17
  }]
}, {
  featureType: "road.highway",
  elementType: "geometry.stroke",
  stylers: [{
    color: "#ffffff"
  }, {
    lightness: 29
  }, {
    weight: 0.2
  }]
}, {
  featureType: "road.arterial",
  elementType: "geometry",
  stylers: [{
    color: "#ffffff"
  }, {
    lightness: 18
  }]
}, {
  featureType: "road.local",
  elementType: "geometry",
  stylers: [{
    color: "#ffffff"
  }, {
    lightness: 16
  }]
}, {
  featureType: "transit",
  elementType: "geometry",
  stylers: [{
    color: "#f2f2f2"
  }, {
    lightness: 19
  }]
}, {
  featureType: "water",
  elementType: "geometry",
  stylers: [{
    color: "#f0f5ff"
  }] // Fresher blue (was #e9e9f2)
}, {
  featureType: "administrative",
  elementType: "geometry.fill",
  stylers: [{
    color: "#fefefe"
  }, {
    lightness: 20
  }]
}, {
  featureType: "administrative",
  elementType: "geometry.stroke",
  stylers: [{
    color: "#fefefe"
  }, {
    lightness: 17
  }, {
    weight: 1.2
  }]
}, {
  featureType: "administrative.country",
  elementType: "geometry.stroke",
  stylers: [{
    visibility: "on"
  }, {
    color: "#e3e3e3"
  }]
}, {
  featureType: "administrative.locality",
  elementType: "labels",
  stylers: [{
    visibility: "off"
  }]
}, {
  featureType: "administrative.neighborhood",
  elementType: "labels",
  stylers: [{
    visibility: "off"
  }]
}, {
  featureType: "administrative.land_parcel",
  elementType: "labels",
  stylers: [{
    visibility: "off"
  }]
}];
const MapAnimator = t0 => {
  const $ = _c(4);
  const {
    coordinates
  } = t0;
  const map = useMap();
  const initialized = useRef(false);
  let t1;
  let t2;
  if ($[0] !== coordinates || $[1] !== map) {
    t1 = () => {
      if (!map || initialized.current) {
        return;
      }
      const handleIdle = () => {
        if (initialized.current) {
          return;
        }
        setTimeout(() => {
          if (coordinates.length > 0) {
            const bounds = new google.maps.LatLngBounds();
            coordinates.forEach(coord => bounds.extend(coord));
            map.fitBounds(bounds, {
              top: 50,
              right: 50,
              bottom: 50,
              left: 50
            });
          } else {
            map.moveCamera({
              center: {
                lat: 28,
                lng: -19
              },
              zoom: 2.2,
              heading: 0,
              tilt: 0
            });
          }
          initialized.current = true;
        }, 600);
        google.maps.event.removeListener(idleListener);
      };
      const idleListener = map.addListener("idle", handleIdle);
      return () => {
        google.maps.event.removeListener(idleListener);
      };
    };
    t2 = [map, coordinates];
    $[0] = coordinates;
    $[1] = map;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
  return null;
};

// Temporary Coordinate Lookup (simplified for major demo countries)
const COUNTRY_COORDINATES: Record<string, {
  lat: number;
  lng: number;
}> = {
  "United States": {
    lat: 39.8283,
    lng: -98.5795
  },
  India: {
    lat: 20.5937,
    lng: 78.9629
  },
  "United Kingdom": {
    lat: 55.3781,
    lng: -3.436
  },
  Germany: {
    lat: 51.1657,
    lng: 10.4515
  },
  Canada: {
    lat: 56.1304,
    lng: -106.3468
  },
  France: {
    lat: 46.2276,
    lng: 2.2137
  },
  Australia: {
    lat: -25.2744,
    lng: 133.7751
  },
  Japan: {
    lat: 36.2048,
    lng: 138.2529
  },
  Netherlands: {
    lat: 52.1326,
    lng: 5.2913
  },
  Sweden: {
    lat: 60.1282,
    lng: 18.6435
  },
  Brazil: {
    lat: -14.235,
    lng: -51.9253
  },
  Spain: {
    lat: 40.4637,
    lng: -3.7492
  },
  Italy: {
    lat: 41.8719,
    lng: 12.5674
  },
  Mexico: {
    lat: 23.6345,
    lng: -102.5528
  },
  Indonesia: {
    lat: -0.7893,
    lng: 113.9213
  },
  Russia: {
    lat: 61.524,
    lng: 105.3188
  },
  Turkey: {
    lat: 38.9637,
    lng: 35.2433
  },
  Poland: {
    lat: 51.9194,
    lng: 19.1451
  },
  Switzerland: {
    lat: 46.8182,
    lng: 8.2275
  },
  Belgium: {
    lat: 50.8503,
    lng: 4.3517
  },
  "South Africa": {
    lat: -30.5595,
    lng: 22.9375
  },
  Argentina: {
    lat: -38.4161,
    lng: -63.6167
  },
  Philippines: {
    lat: 12.8797,
    lng: 121.774
  },
  Malaysia: {
    lat: 4.2105,
    lng: 101.9758
  },
  Nigeria: {
    lat: 9.082,
    lng: 8.6753
  },
  Chile: {
    lat: -35.6751,
    lng: -71.543
  },
  Colombia: {
    lat: 4.5709,
    lng: -74.2973
  },
  "Saudi Arabia": {
    lat: 23.8859,
    lng: 45.0792
  },
  Portugal: {
    lat: 39.3999,
    lng: -8.2245
  },
  Romania: {
    lat: 45.9432,
    lng: 24.9668
  },
  Greece: {
    lat: 39.0742,
    lng: 21.8243
  },
  Hungary: {
    lat: 47.1625,
    lng: 19.5033
  },
  Pakistan: {
    lat: 30.3753,
    lng: 69.3451
  },
  Austria: {
    lat: 47.5162,
    lng: 14.5501
  },
  Ukraine: {
    lat: 48.3794,
    lng: 31.1656
  },
  "Czech Republic": {
    lat: 49.8175,
    lng: 15.473
  },
  Vietnam: {
    lat: 14.0583,
    lng: 108.2772
  },
  Thailand: {
    lat: 15.87,
    lng: 100.9925
  },
  Bulgaria: {
    lat: 42.7339,
    lng: 25.4858
  },
  Morocco: {
    lat: 31.7917,
    lng: -7.0926
  },
  Peru: {
    lat: -9.19,
    lng: -75.0152
  },
  Moldova: {
    lat: 47.4116,
    lng: 28.3699
  },
  Montenegro: {
    lat: 42.7087,
    lng: 19.3744
  },
  Monaco: {
    lat: 43.7384,
    lng: 7.4246
  },
  Luxembourg: {
    lat: 49.8153,
    lng: 6.1296
  },
  Lithuania: {
    lat: 55.1694,
    lng: 23.8813
  },
  Latvia: {
    lat: 56.8796,
    lng: 24.6032
  },
  "United Arab Emirates": {
    lat: 23.4241,
    lng: 53.8478
  },
  "South Korea": {
    lat: 35.9078,
    lng: 127.7669
  },
  Ireland: {
    lat: 53.1424,
    lng: -7.6921
  },
  Egypt: {
    lat: 26.8206,
    lng: 30.8025
  },
  Israel: {
    lat: 31.0461,
    lng: 34.8516
  },
  Singapore: {
    lat: 1.3521,
    lng: 103.8198
  },
  Norway: {
    lat: 60.472,
    lng: 8.4689
  },
  Finland: {
    lat: 61.9241,
    lng: 25.7482
  },
  Denmark: {
    lat: 56.2639,
    lng: 9.5018
  },
  Croatia: {
    lat: 45.1,
    lng: 15.2
  },
  "New Zealand": {
    lat: -40.9006,
    lng: 174.886
  },
  China: {
    lat: 35.8617,
    lng: 104.1954
  },
  Venezuela: {
    lat: 6.4238,
    lng: -66.5897
  },
  Qatar: {
    lat: 25.3548,
    lng: 51.1839
  },
  Serbia: {
    lat: 44.0165,
    lng: 21.0059
  },
  Slovakia: {
    lat: 48.669,
    lng: 19.699
  },
  Belarus: {
    lat: 53.7098,
    lng: 27.9534
  },
  Ecuador: {
    lat: -1.8312,
    lng: -78.1834
  },
  Slovenia: {
    lat: 46.1512,
    lng: 14.9955
  },
  "Hong Kong": {
    lat: 22.3193,
    lng: 114.1694
  },
  Bangladesh: {
    lat: 23.685,
    lng: 90.3563
  },
  Iraq: {
    lat: 33.2232,
    lng: 43.6793
  },
  "Puerto Rico": {
    lat: 18.2208,
    lng: -66.5901
  },
  "Bosnia and Herzegovina": {
    lat: 43.9159,
    lng: 17.6791
  },
  Estonia: {
    lat: 58.5953,
    lng: 25.0136
  },
  Georgia: {
    lat: 42.3154,
    lng: 43.3569
  },
  Iceland: {
    lat: 64.9631,
    lng: -19.0208
  },
  Jamaica: {
    lat: 18.1096,
    lng: -77.2975
  }
};

// Smooth pan to hovered country
const MapPanner = t0 => {
  const $ = _c(4);
  const {
    hoveredCountry
  } = t0;
  const map = useMap();
  const originalCenter = useRef(null);
  const originalZoom = useRef(null);
  const panTimeoutRef = useRef(null);
  const returnTimeoutRef = useRef(null);
  let t1;
  let t2;
  if ($[0] !== hoveredCountry || $[1] !== map) {
    t1 = () => {
      if (!map) {
        return;
      }
      if (originalCenter.current === null) {
        const center = map.getCenter();
        if (center) {
          originalCenter.current = {
            lat: center.lat(),
            lng: center.lng()
          };
          originalZoom.current = map.getZoom() || 2.2;
        }
      }
      if (returnTimeoutRef.current) {
        clearTimeout(returnTimeoutRef.current);
        returnTimeoutRef.current = null;
      }
      if (hoveredCountry && COUNTRY_COORDINATES[hoveredCountry]) {
        if (panTimeoutRef.current) {
          clearTimeout(panTimeoutRef.current);
        }
        panTimeoutRef.current = setTimeout(() => {
          const coords = COUNTRY_COORDINATES[hoveredCountry];
          map.panTo(coords);
          const currentZoom = map.getZoom() || 2.2;
          if (currentZoom < 3) {
            setTimeout(() => {
              map.setZoom(3);
            }, 150);
          }
        }, 50);
      } else {
        returnTimeoutRef.current = setTimeout(() => {
          if (originalCenter.current && originalZoom.current !== null) {
            map.panTo(originalCenter.current);
            setTimeout(() => {
              if (originalZoom.current !== null) {
                map.setZoom(originalZoom.current);
              }
            }, 150);
          }
        }, 150);
      }
      return () => {
        if (panTimeoutRef.current) {
          clearTimeout(panTimeoutRef.current);
        }
        if (returnTimeoutRef.current) {
          clearTimeout(returnTimeoutRef.current);
        }
      };
    };
    t2 = [map, hoveredCountry];
    $[0] = hoveredCountry;
    $[1] = map;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
  return null;
};

// Custom OverlayView implementation since it is not exported by the library
const CustomOverlayView = ({
  position,
  children,
  zIndex
}: {
  position: {
    lat: number;
    lng: number;
  };
  children: React.ReactNode;
  zIndex?: number;
}) => {
  const map = useMap();
  const [container] = useState(() => {
    if (typeof document !== "undefined") return document.createElement("div");
    return null;
  });
  const [overlay, setOverlay] = useState<any>(null);
  useEffect(() => {
    if (!map || !container || typeof google === "undefined") return;
    class Overlay extends google.maps.OverlayView {
      container: HTMLDivElement;
      position: {
        lat: number;
        lng: number;
      };
      zIndex?: number;
      constructor(container: HTMLDivElement, position: {
        lat: number;
        lng: number;
      }, zIndex?: number) {
        super();
        this.container = container;
        this.position = position;
        this.zIndex = zIndex;
      }
      onAdd() {
        const panes = this.getPanes();
        if (panes?.floatPane) {
          panes.floatPane.appendChild(this.container);
        }
      }
      draw() {
        const projection = this.getProjection();
        if (!projection) return;
        const point = projection.fromLatLngToDivPixel(new google.maps.LatLng(this.position));
        if (point) {
          this.container.style.position = "absolute";
          this.container.style.left = point.x + "px";
          this.container.style.top = point.y + "px";
          if (this.zIndex) this.container.style.zIndex = this.zIndex.toString();
        }
      }
      onRemove() {
        if (this.container.parentNode) {
          this.container.parentNode.removeChild(this.container);
        }
      }
    }
    const instance = new Overlay(container, position, zIndex);
    instance.setMap(map);
    setOverlay(instance);
    return () => {
      instance.setMap(null);
    };
  }, [map, container]);
  useEffect(() => {
    if (overlay && position) {
      overlay.position = position;
      overlay.draw();
    }
  }, [position, overlay]);
  if (!container) return null;
  return createPortal(children, container);
};
type RichMarkerProps = {
  country: string;
  metric: number;
  title: string;
  isHighlighted: boolean;
  onHover: (country: string | null) => void;
};
const RichMarker = t0 => {
  const $ = _c(43);
  const {
    metric,
    title,
    isHighlighted,
    onHover
  } = t0;
  const coords = COUNTRY_COORDINATES[title];
  if (!coords) {
    return null;
  }
  let t1;
  if ($[0] !== title) {
    t1 = countryToCode[title] || title.toLowerCase().slice(0, 2);
    $[0] = title;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const countryCode = t1;
  const flagUrl = `https://hatscripts.github.io/circle-flags/flags/${countryCode}.svg`;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      type: "spring" as const,
      stiffness: 400,
      damping: 35
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const springConfig = t2;
  const t3 = isHighlighted ? 100 : 1;
  let t4;
  if ($[3] !== t3) {
    t4 = {
      x: "-50%",
      y: "-100%",
      marginTop: "-8px",
      zIndex: t3
    };
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const t5 = isHighlighted ? 1.08 : 1;
  const t6 = isHighlighted ? "rgba(255, 255, 255, 1)" : "rgba(255, 255, 255, 0.92)";
  const t7 = isHighlighted ? "0 20px 25px -5px rgba(0, 0, 0, 0.15), 0 8px 10px -6px rgba(0, 0, 0, 0.1)" : "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.1)";
  let t8;
  if ($[5] !== t5 || $[6] !== t6 || $[7] !== t7) {
    t8 = {
      scale: t5,
      backgroundColor: t6,
      boxShadow: t7
    };
    $[5] = t5;
    $[6] = t6;
    $[7] = t7;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] !== onHover || $[10] !== title) {
    t9 = () => onHover(title);
    $[9] = onHover;
    $[10] = title;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  let t10;
  if ($[12] !== onHover) {
    t10 = () => onHover(null);
    $[12] = onHover;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  const t11 = isHighlighted ? 1.15 : 1;
  let t12;
  if ($[14] !== t11) {
    t12 = {
      scale: t11
    };
    $[14] = t11;
    $[15] = t12;
  } else {
    t12 = $[15];
  }
  let t13;
  if ($[16] !== flagUrl || $[17] !== t12 || $[18] !== title) {
    t13 = <motion.img src={flagUrl} alt={title} className="h-4 w-4 rounded-full shadow-sm" animate={t12} transition={springConfig} onError={_temp} />;
    $[16] = flagUrl;
    $[17] = t12;
    $[18] = title;
    $[19] = t13;
  } else {
    t13 = $[19];
  }
  let t14;
  if ($[20] !== metric) {
    t14 = Math.round(metric);
    $[20] = metric;
    $[21] = t14;
  } else {
    t14 = $[21];
  }
  let t15;
  if ($[22] !== t14) {
    t15 = <span className="text-xs font-bold text-gray-800">{t14}%</span>;
    $[22] = t14;
    $[23] = t15;
  } else {
    t15 = $[23];
  }
  let t16;
  if ($[24] !== isHighlighted || $[25] !== title) {
    t16 = isHighlighted && <motion.span className="overflow-hidden whitespace-nowrap text-xs font-medium text-gray-600" initial={{
      width: 0,
      opacity: 0
    }} animate={{
      width: "auto",
      opacity: 1
    }} exit={{
      width: 0,
      opacity: 0
    }} transition={{
      duration: 0.25,
      ease: [0.32, 0.72, 0, 1]
    }}>{title}</motion.span>;
    $[24] = isHighlighted;
    $[25] = title;
    $[26] = t16;
  } else {
    t16 = $[26];
  }
  let t17;
  if ($[27] !== t16) {
    t17 = <AnimatePresence mode="wait">{t16}</AnimatePresence>;
    $[27] = t16;
    $[28] = t17;
  } else {
    t17 = $[28];
  }
  const t18 = isHighlighted ? "rgba(255, 255, 255, 1)" : "rgba(255, 255, 255, 0.92)";
  let t19;
  if ($[29] !== t18) {
    t19 = <motion.div className="absolute -bottom-1 left-1/2 h-2 w-2 -translate-x-1/2 rotate-45" animate={{
      backgroundColor: t18
    }} transition={springConfig} />;
    $[29] = t18;
    $[30] = t19;
  } else {
    t19 = $[30];
  }
  let t20;
  if ($[31] !== t10 || $[32] !== t13 || $[33] !== t15 || $[34] !== t17 || $[35] !== t19 || $[36] !== t4 || $[37] !== t8 || $[38] !== t9) {
    t20 = <motion.div className="relative flex cursor-pointer items-center gap-2 rounded-full px-2.5 py-1.5 ring-1 ring-black/5 backdrop-blur-sm" style={t4} initial={false} animate={t8} transition={springConfig} onHoverStart={t9} onHoverEnd={t10}>{t13}{t15}{t17}{t19}</motion.div>;
    $[31] = t10;
    $[32] = t13;
    $[33] = t15;
    $[34] = t17;
    $[35] = t19;
    $[36] = t4;
    $[37] = t8;
    $[38] = t9;
    $[39] = t20;
  } else {
    t20 = $[39];
  }
  let t21;
  if ($[40] !== coords || $[41] !== t20) {
    t21 = <CustomOverlayView position={coords}>{t20}</CustomOverlayView>;
    $[40] = coords;
    $[41] = t20;
    $[42] = t21;
  } else {
    t21 = $[42];
  }
  return t21;
};
const MapControls = t0 => {
  const $ = _c(28);
  const {
    onToggleFullScreen,
    isFullScreen
  } = t0;
  const map = useMap();
  if (!map) {
    return null;
  }
  let t1;
  if ($[0] !== isFullScreen || $[1] !== onToggleFullScreen) {
    t1 = !isFullScreen && <motion.div className="absolute right-3 top-3" initial={{
      opacity: 0,
      scale: 0.9
    }} animate={{
      opacity: 1,
      scale: 1
    }} transition={{
      type: "spring",
      stiffness: 400,
      damping: 25
    }}><button type="button" className="flex h-10 w-10 items-center justify-center rounded-full bg-white text-gray-700 shadow-lg ring-1 ring-black/5 transition-all hover:bg-gray-50 hover:text-black hover:shadow-xl active:scale-95" onClick={onToggleFullScreen} aria-label="Toggle Full Screen"><Maximize2 size={16} strokeWidth={2.5} /></button></motion.div>;
    $[0] = isFullScreen;
    $[1] = onToggleFullScreen;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const t2 = isFullScreen ? "auto" : 56;
  const t3 = isFullScreen ? 24 : "auto";
  let t4;
  if ($[3] !== t2 || $[4] !== t3) {
    t4 = {
      top: t2,
      bottom: t3,
      right: 12
    };
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      type: "spring",
      stiffness: 400,
      damping: 30
    };
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== map) {
    t6 = () => map.setZoom((map.getZoom() || 0) + 1);
    $[7] = map;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  let t8;
  let t9;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      scale: 1.05
    };
    t8 = {
      scale: 0.95
    };
    t9 = <Plus size={16} strokeWidth={2.5} />;
    $[9] = t7;
    $[10] = t8;
    $[11] = t9;
  } else {
    t7 = $[9];
    t8 = $[10];
    t9 = $[11];
  }
  let t10;
  if ($[12] !== t6) {
    t10 = <motion.button type="button" className="flex h-10 w-10 items-center justify-center rounded-full bg-white text-gray-700 shadow-lg ring-1 ring-black/5 transition-all hover:bg-gray-50 hover:text-black hover:shadow-xl active:scale-95" onClick={t6} aria-label="Zoom in" whileHover={t7} whileTap={t8}>{t9}</motion.button>;
    $[12] = t6;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  if ($[14] !== map) {
    t11 = () => map.setZoom((map.getZoom() || 0) - 1);
    $[14] = map;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  let t12;
  let t13;
  let t14;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = {
      scale: 1.05
    };
    t13 = {
      scale: 0.95
    };
    t14 = <Minus size={16} strokeWidth={2.5} />;
    $[16] = t12;
    $[17] = t13;
    $[18] = t14;
  } else {
    t12 = $[16];
    t13 = $[17];
    t14 = $[18];
  }
  let t15;
  if ($[19] !== t11) {
    t15 = <motion.button type="button" className="flex h-10 w-10 items-center justify-center rounded-full bg-white text-gray-700 shadow-lg ring-1 ring-black/5 transition-all hover:bg-gray-50 hover:text-black hover:shadow-xl active:scale-95" onClick={t11} aria-label="Zoom out" whileHover={t12} whileTap={t13}>{t14}</motion.button>;
    $[19] = t11;
    $[20] = t15;
  } else {
    t15 = $[20];
  }
  let t16;
  if ($[21] !== t10 || $[22] !== t15 || $[23] !== t4) {
    t16 = <motion.div className="absolute flex flex-col gap-2" initial={false} animate={t4} transition={t5}>{t10}{t15}</motion.div>;
    $[21] = t10;
    $[22] = t15;
    $[23] = t4;
    $[24] = t16;
  } else {
    t16 = $[24];
  }
  let t17;
  if ($[25] !== t1 || $[26] !== t16) {
    t17 = <>{t1}{t16}</>;
    $[25] = t1;
    $[26] = t16;
    $[27] = t17;
  } else {
    t17 = $[27];
  }
  return t17;
};
type InnerMapProps = {
  isFullScreen: boolean;
  setIsFullScreen: (value: boolean) => void;
  mapData: any;
  locationStats: any[] | null;
  hoveredCountry: string | null;
  onHoverCountry: (country: string | null) => void;
};
const InnerMap = t0 => {
  const $ = _c(23);
  const {
    isFullScreen,
    setIsFullScreen,
    locationStats,
    hoveredCountry,
    onHoverCountry
  } = t0;
  let t1;
  bb0: {
    if (!locationStats || locationStats.length === 0) {
      let t2;
      if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = [];
        $[0] = t2;
      } else {
        t2 = $[0];
      }
      t1 = t2;
      break bb0;
    }
    let t2;
    if ($[1] !== locationStats) {
      t2 = locationStats.slice(0, 5).map(_temp2).filter(Boolean);
      $[1] = locationStats;
      $[2] = t2;
    } else {
      t2 = $[2];
    }
    t1 = t2;
  }
  const markerCoordinates = t1;
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      lat: 35,
      lng: 15
    };
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== markerCoordinates) {
    t3 = <MapAnimator coordinates={markerCoordinates} />;
    $[4] = markerCoordinates;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== hoveredCountry) {
    t4 = <MapPanner hoveredCountry={hoveredCountry} />;
    $[6] = hoveredCountry;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== isFullScreen || $[9] !== setIsFullScreen) {
    t5 = () => setIsFullScreen(!isFullScreen);
    $[8] = isFullScreen;
    $[9] = setIsFullScreen;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== isFullScreen || $[12] !== t5) {
    t6 = <MapControls onToggleFullScreen={t5} isFullScreen={isFullScreen} />;
    $[11] = isFullScreen;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== hoveredCountry || $[15] !== locationStats || $[16] !== onHoverCountry) {
    t7 = locationStats && locationStats.slice(0, 5).map(item_0 => <RichMarker key={item_0.title} title={item_0.title} country={item_0.title} metric={item_0.metric} isHighlighted={hoveredCountry === item_0.title} onHover={onHoverCountry} />);
    $[14] = hoveredCountry;
    $[15] = locationStats;
    $[16] = onHoverCountry;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== t3 || $[19] !== t4 || $[20] !== t6 || $[21] !== t7) {
    t8 = <Map mapTypeId="roadmap" defaultZoom={2} defaultCenter={t2} gestureHandling="greedy" disableDefaultUI={true} zoomControl={false} mapTypeControl={false} streetViewControl={false} fullscreenControl={false}>{t3}{t4}{t6}{t7}</Map>;
    $[18] = t3;
    $[19] = t4;
    $[20] = t6;
    $[21] = t7;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  return t8;
};
export default function FollowersMapChart(t0) {
  const $ = _c(36);
  const {
    mapData,
    isEmpty,
    isActive
  } = t0;
  const [isFullScreen, setIsFullScreen] = useState(false);
  const [locationStats, setLocationStats] = useState(null);
  const [hoveredCountry, setHoveredCountry] = useState(null);
  let t1;
  let t2;
  if ($[0] !== locationStats || $[1] !== mapData) {
    t1 = () => {
      if (!mapData || locationStats) {
        return;
      }
      const formattedData = Object.entries(mapData).map(_temp3).sort(_temp4);
      setLocationStats(formattedData);
    };
    t2 = [mapData, locationStats];
    $[0] = locationStats;
    $[1] = mapData;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
  useAccountPlatform();
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      type: "spring" as const,
      stiffness: 400,
      damping: 30
    };
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const listSpringConfig = t3;
  const t4 = isFullScreen ? "" : "max-h-[240px] overflow-hidden lg:max-h-[380px]";
  let t5;
  if ($[5] !== t4) {
    t5 = clsx("lg:col-span-2 block rounded-xl", t4);
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const t6 = isEmpty ? null : locationStats;
  let t7;
  if ($[7] !== hoveredCountry || $[8] !== isFullScreen || $[9] !== mapData || $[10] !== t6) {
    t7 = <div className="relative h-[240px] w-full overflow-hidden rounded-xl bg-gray-100 lg:h-[360px]"><InnerMap isFullScreen={isFullScreen} setIsFullScreen={setIsFullScreen} mapData={mapData} locationStats={t6} hoveredCountry={hoveredCountry} onHoverCountry={setHoveredCountry} /></div>;
    $[7] = hoveredCountry;
    $[8] = isFullScreen;
    $[9] = mapData;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== hoveredCountry || $[13] !== isEmpty || $[14] !== isFullScreen || $[15] !== locationStats || $[16] !== mapData) {
    t8 = isFullScreen && <motion.div initial={{
      opacity: 0,
      scale: 0.95
    }} animate={{
      opacity: 1,
      scale: 1
    }} exit={{
      opacity: 0,
      scale: 0.95
    }} transition={{
      duration: 0.3,
      ease: [0.32, 0.72, 0, 1]
    }} className="fixed inset-0 z-50 flex items-center justify-center bg-white/80 p-6 backdrop-blur-md"><div className="relative h-full w-full overflow-hidden rounded-2xl shadow-2xl ring-1 ring-black/5"><motion.button onClick={() => setIsFullScreen(false)} className="absolute right-6 top-6 z-[60] flex h-10 w-10 items-center justify-center rounded-full bg-white text-gray-700 shadow-lg ring-1 ring-black/5 hover:bg-gray-50 hover:text-black hover:shadow-xl" initial={{
          opacity: 0,
          scale: 0.8
        }} animate={{
          opacity: 1,
          scale: 1
        }} exit={{
          opacity: 0,
          scale: 0.8
        }} transition={{
          type: "spring",
          stiffness: 400,
          damping: 25
        }} whileHover={{
          scale: 1.05
        }} whileTap={{
          scale: 0.95
        }}><X size={18} strokeWidth={2.5} /></motion.button><InnerMap isFullScreen={isFullScreen} setIsFullScreen={setIsFullScreen} mapData={mapData} locationStats={isEmpty ? null : locationStats} hoveredCountry={hoveredCountry} onHoverCountry={setHoveredCountry} /></div></motion.div>;
    $[12] = hoveredCountry;
    $[13] = isEmpty;
    $[14] = isFullScreen;
    $[15] = locationStats;
    $[16] = mapData;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== t8) {
    t9 = <AnimatePresence>{t8}</AnimatePresence>;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== t7 || $[21] !== t9) {
    t10 = <APIProvider apiKey={process.env.NEXT_PUBLIC_GOOGLE_MAPS_API_KEY as string}>{t7}{t9}</APIProvider>;
    $[20] = t7;
    $[21] = t9;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] !== t10 || $[24] !== t5) {
    t11 = <div className={t5}>{t10}</div>;
    $[23] = t10;
    $[24] = t5;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  let t12;
  if ($[26] !== hoveredCountry || $[27] !== isActive || $[28] !== isEmpty || $[29] !== locationStats) {
    t12 = isEmpty ? <div className="flex min-h-[240px] flex-col items-center justify-center px-4 py-6 text-center lg:min-h-[320px]"><div className="relative mb-4"><div className="relative"><div className="flex h-12 w-12 items-center justify-center rounded-full bg-sky-50"><GlobeAltIcon className="h-6 w-6 text-sky-400" /></div><div className="absolute -right-1 -top-0.5 h-2 w-2 rounded-full bg-sky-300 ring-2 ring-white" /><div className="absolute -bottom-0.5 -left-0.5 h-1.5 w-1.5 rounded-full bg-sky-200 ring-2 ring-white" /></div></div><p className="text-base font-medium text-gray-900">{isActive ? "Mapping your audience..." : "Waiting to start..."}</p><p className="mt-1.5 max-w-[200px] text-[13px] leading-relaxed text-gray-500">{isActive ? "Location data will appear here as your followers grow." : "Activate your account to see where your new followers are from."}</p></div> : locationStats && locationStats.length > 0 && locationStats.map((item, index) => {
      const countryCode = countryToCode[item.title] || item.title.toLowerCase().slice(0, 2);
      const flagUrl = `https://hatscripts.github.io/circle-flags/flags/${countryCode}.svg`;
      const isHighlighted = hoveredCountry === item.title;
      const isOnMap = index < 5;
      return <motion.div key={item.title} className={clsx("relative flex items-center gap-3 rounded-xl px-3 py-2.5 transition-colors", isOnMap ? "cursor-pointer" : "cursor-default", !isHighlighted && "hover:bg-gray-50")} initial={false} animate={{
        backgroundColor: isHighlighted ? "rgba(59, 130, 246, 0.08)" : "rgba(255, 255, 255, 0)"
      }} transition={listSpringConfig} onHoverStart={() => isOnMap && setHoveredCountry(item.title)} onHoverEnd={() => isOnMap && setHoveredCountry(null)}><motion.img src={flagUrl} alt={`${item.title} flag`} className="h-6 w-6 shrink-0 rounded-full object-cover ring-1 ring-gray-900/10" animate={{
          scale: isHighlighted ? 1.1 : 1
        }} transition={listSpringConfig} onError={_temp5} /><motion.span className="min-w-0 flex-1 truncate text-[14px] font-medium text-gray-700" animate={{
          color: isHighlighted ? "#1d4ed8" : "#374151"
        }} transition={listSpringConfig}>{item.title}</motion.span><div className="w-16 shrink-0 sm:w-20 lg:w-16"><div className="relative h-1.5 w-full overflow-hidden rounded-full bg-gray-100"><motion.div className="absolute h-full rounded-full bg-blue-500" initial={false} animate={{
              width: `${Math.round(item.metric)}%`,
              backgroundColor: isHighlighted ? "#2563eb" : "#3b82f6"
            }} transition={{
              ...listSpringConfig,
              duration: 0.5
            }} /></div></div><motion.span className="shrink-0 text-[13px] font-semibold tabular-nums text-gray-500" animate={{
          color: isHighlighted ? "#1d4ed8" : "#6b7280"
        }} transition={listSpringConfig}>{Math.round(item.metric)}%</motion.span></motion.div>;
    });
    $[26] = hoveredCountry;
    $[27] = isActive;
    $[28] = isEmpty;
    $[29] = locationStats;
    $[30] = t12;
  } else {
    t12 = $[30];
  }
  let t13;
  if ($[31] !== t12) {
    t13 = <div className="col-span-1 flex flex-col gap-1">{t12}</div>;
    $[31] = t12;
    $[32] = t13;
  } else {
    t13 = $[32];
  }
  let t14;
  if ($[33] !== t11 || $[34] !== t13) {
    t14 = <div className="relative grid grid-cols-1 items-center gap-4 pb-2.5 lg:grid-cols-3 lg:gap-6">{t11}{t13}</div>;
    $[33] = t11;
    $[34] = t13;
    $[35] = t14;
  } else {
    t14 = $[35];
  }
  return t14;
}
function _temp5(e) {
  (e.currentTarget as HTMLImageElement).style.display = "none";
}
function _temp4(a, b) {
  return b.metric - a.metric;
}
function _temp3(t0) {
  const [key, value] = t0;
  return {
    title: key,
    metric: Number(value) * 100,
    emoji: countryEmojis[key] || "\uD83C\uDFF3\uFE0F"
  };
}
function _temp(e) {
  (e.currentTarget as HTMLImageElement).style.display = "none";
}
function _temp2(item) {
  return COUNTRY_COORDINATES[item.title];
}